import React from 'react';
import css from './PaymentTable.module.css';

export default function PaymentTable1(props) {
  const { style } = props;

  return (
    <table style={style} className={css.table}>
      <tr>
        <th>MARKETPLACE</th>
        <th className={css.planCol}>NETWORK</th>
        <th className={css.planCol}>VERIFIED</th>
      </tr>
      <tr>
        <td>Professional Coaching Profile in the Viveka Marketplace</td>
        <td>x</td>
        <td>x</td>
      </tr>
      <tr>
        <td>Access to the Viveka Resource Library and Community</td>
        <td>x</td>
        <td>x</td>
      </tr>
      <tr>
        <td>Visibility to Individuals and Organizations Seeking Coaching</td>
        <td>x</td>
        <td>x</td>
      </tr>
      <tr>
        <td>Invitations to Viveka Hosted Events and Webinars</td>
        <td>x</td>
        <td>x</td>
      </tr>
      <tr>
        <td>Monthly Coaching Industry Insights</td>
        <td>x</td>
        <td>x</td>
      </tr>
      <tr>
        <td>Verified Coach Badge Displayed on Your Profile</td>
        <td></td>
        <td>x</td>
      </tr>
      <tr>
        <td>Priority Placement in Search Results and Recommendations</td>
        <td></td>
        <td>x</td>
      </tr>
      <tr>
        <td>Eligibility for Enterprise and Organizational Coaching Contracts</td>
        <td></td>
        <td>x</td>
      </tr>
      <tr>
        <td>Featured in Viveka Spotlight Opportunities and Case Studies</td>
        <td></td>
        <td>x</td>
      </tr>
    </table>
  );
}
